import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fedex': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M586 284.5l54 60.5h-64.4l-22.3-25-22.1 25h-212.2v-11.9h-0.5c-7.9 11.7-20.8 18.6-34.9 18.6-32.7 0-56.4-26.4-60.1-56.9h-85.5c0 23.5 31.1 35.5 45.8 14.6h42c-27.6 67.7-130.2 49.4-130.2-23.7 0-6.4 0.8-12.5 2.3-18.2h-48.9v77.5h-49v-184.4h109v41.1h-60v26.2h54.8v24.2c24.5-43.6 103.9-45.4 121.9 14 7.5-25.5 28.9-44.9 57.3-44.9 13.9 0 25.8 3.8 35.4 14.8h0.5v-75.5h151.2v48.1h-56.1v16h118.7l22.5 24.8 21.7-24.8h62.4zM139.3 267.9h46.5c-4.8-25.6-40.4-26.3-46.5 0zM292.7 316.8c34.5 0 32.6-62.8 0-62.8-34 0-34.6 62.8 0 62.8zM460.5 335.9v-29.6h-56.1v-44.7h56.1v-28.1h-55.5v-33.9h56.1v-30.2h-95v166.5h94.4zM414.6 296.1h56.1v45.6l50.7-57-50.7-57v44h-56.1v24.4zM553.2 306.4l26.3 29.5h40.5l-46-51.4 45.4-51h-38.5l-25.6 29.3-26.6-29.3h-39.7l45.6 51.2-45.6 51.2h38.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/fedex.js
// module id = 821
// module chunks = 0